"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.comma = exports.createSvg = void 0;
var fillXY_1 = require("../common/fillXY");
var BarChart_1 = require("./charts/BarChart");
var LineChart_1 = require("./charts/LineChart");
var MultibarChart_1 = require("./charts/MultibarChart");
var RangeChart_1 = require("./charts/RangeChart");
var StackbarChart_1 = require("./charts/StackbarChart");
var fontface_lato_1 = require("./fontface-lato");
var comma = function (n) {
    return (Math.round(n * 100) / 100).toLocaleString();
};
exports.comma = comma;
var Chart = function (svg, config) {
    if (config.type === 'multibar') {
        return MultibarChart_1.MultibarChart(svg, config);
    }
    if (config.type === 'bar') {
        return BarChart_1.BarChart(svg, config);
    }
    if (config.type === 'line') {
        return LineChart_1.LineChart(svg, config);
    }
    if (config.type === 'range') {
        return RangeChart_1.RangeChart(svg, config);
    }
    return StackbarChart_1.StackbarChart(svg, config);
};
var createSvg = function (svg, groupConfig) {
    var chartCount = groupConfig.charts.length;
    var canvasWidth = Math.max.apply(Math, groupConfig.charts.map(function (it) { return it.width; })) + 2 * groupConfig.margin;
    var canvasHeight = groupConfig.charts.map(function (it) { return it.height - (it.offsetY ? it.offsetY : 0); }).reduce(function (acc, it) { return (groupConfig.merged ? 0 : acc) + it; }, 0) + (chartCount + 1) * groupConfig.margin;
    svg.viewbox(0, 0, canvasWidth, canvasHeight);
    var defs = svg.defs();
    var fontFaceLato = svg.fontface('lato', fontface_lato_1.fontFaceStr);
    var textStyle = svg.style();
    textStyle.rule('text', { 'font-family': 'lato' });
    textStyle.rule('text.legend', { 'font-family': 'monospace' });
    defs.add(fontFaceLato);
    defs.add(textStyle);
    svg.chartXys = null;
    svg.add(defs);
    svg.add(svg.rect('100%', '100%').fill('transparent'));
    var charts = fillXY_1.fillXY(groupConfig.charts, groupConfig.margin, groupConfig.merged);
    var chartXys = charts.map(function (it) { return ({ x: it.x, y: it.y, w: it.width, h: it.height }); });
    svg.chartXys = chartXys;
    var chartRefs = charts.map(function (it) {
        var innerSvg = svg.nested();
        var child = Chart(innerSvg, it);
        child.svg.x(it.x || 0)
            .y(it.y)
            .width(it.width)
            .height(it.height);
        return child;
    });
    svg.getXYIndex = function (x, y) {
        return chartRefs.map(function (it) { return it.getXY(x, y); });
    };
    svg.getDataPointGroup = function () {
        return chartRefs.map(function (it) { return it.getDataPointGroup(); });
    };
    svg.getPopupInfo = function (i) {
        return chartRefs.map(function (it) { return it.getPopupInfo(i); });
    };
    return { svg: svg };
};
exports.createSvg = createSvg;
